class LookbookSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    console.log('LookbookSlider: Constructor initialized', this);
  }

  connectedCallback() {
    console.log('LookbookSlider: Connected to DOM', this);
    // Use requestAnimationFrame to ensure DOM is fully parsed and styled
    requestAnimationFrame(() => {
      this.initSwiper();
      this.initEvents();
    });
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
    }
  }

  initSwiper() {
    const container = this.querySelector('.swiper');

    // Selectors matched to 'dot-pagination.liquid' snippet
    const prevEl = this.querySelector('.dot-pagination__arrow--prev');
    const nextEl = this.querySelector('.dot-pagination__arrow--next');

    if (!container) {
      console.error('LookbookSlider: Swiper container not found');
      return;
    }

    // Initialize Swiper with standard navigation binding
    try {
      this.swiperInstance = new Swiper(container, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: true,
        loop: true,
        grabCursor: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          750: {
            slidesPerView: 4,
            spaceBetween: 24,
            centeredSlides: false,
            loop: true,
          }
        },
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
        on: {
          init: (swiper) => {
            console.log('LookbookSlider: Swiper initialized', swiper);
            // Initial update
            this.updateActiveDot(swiper.realIndex);
          },
          slideChange: (swiper) => {
            console.log('LookbookSlider: Slide Change to index', swiper.realIndex);
            this.updateActiveDot(swiper.realIndex);
          }
        }
      });
    } catch (e) {
      console.error('LookbookSlider: Error initializing Swiper', e);
    }
  }

  initEvents() {
    // USE EVENT DELEGATION on the custom element itself
    // This catches clicks bubbling up from ANY child element (dots, arrows, swiper)
    this.addEventListener('click', (e) => {
      // Check if we clicked something relevant
      const target = e.target;

      // 1. Check for Dots
      const dot = target.closest('.dot-pagination__dot');
      if (dot) {
        e.preventDefault();
        const targetIndex = parseInt(dot.dataset.index);
        console.log('LookbookSlider: Dot Click detected via delegation', targetIndex);

        if (!isNaN(targetIndex) && this.swiperInstance) {
          if (this.swiperInstance.params.loop) {
            this.swiperInstance.slideToLoop(targetIndex);
          } else {
            this.swiperInstance.slideTo(targetIndex);
          }
        }
        return;
      }

      // 2. Check for Arrows (Manual Fallback if Swiper misses click)
      // Usually Swiper catches these if `navigation` is set up correctly, 
      // but if z-index or other issues interfere, this is a backup.
      const prev = target.closest('.dot-pagination__arrow--prev');
      if (prev) {
        // e.preventDefault(); // Let Swiper handle if it can, but log it.
        console.log('LookbookSlider: Prev Arrow Click detected via delegation');
        // If swiper didn't move automatically, we could force it here, 
        // but let's trust Swiper usually works if Elements are passed.
        // However, if the user says "not working", we can force checking if swiper is active.
        if (this.swiperInstance && this.swiperInstance.isBeginning && !this.swiperInstance.params.loop) {
          console.log('LookbookSlider: At beginning (no loop), prev disabled');
        }
        return;
      }

      const next = target.closest('.dot-pagination__arrow--next');
      if (next) {
        console.log('LookbookSlider: Next Arrow Click detected via delegation');
        return;
      }
    });

    console.log('LookbookSlider: Event delegation attached to root element');
  }

  updateActiveDot(activeIndex) {
    // Update visuals
    const dots = this.querySelectorAll('.dot-pagination__dot');
    dots.forEach(dot => {
      const dotIndex = parseInt(dot.dataset.index);
      if (dotIndex === activeIndex) {
        dot.classList.add('is-active');
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.classList.remove('is-active');
        dot.removeAttribute('aria-current');
      }
    });
  }
}

customElements.define('lookbook-slider', LookbookSlider);
